<template>
    <div
        class="col-12 col-lg-6 mini-hero-banner__slot--single"
    >
        <CustomCarousel
            class="single-mini-hero-banner__carousel"
            :per-page="1"
            :navigation-enabled="navigationEnabled"
            :type-navigation="'isMiniNavigation'"
            :pagination-enabled="false"
            :loop="true"
            :autoplay="true"
            :autoplay-timeout="10000"
        >
            <template
                v-for="(slotData, index) in slotsToDisplay"
            >
                <slide
                    v-if="!keysToBeNotDisplayed.includes(slotData)"
                    :key="`miniHeroBanner${side}-${index}`"
                >
                    <DoubleClick
                        :id="slotData"
                        :key="index"
                        :progressive-image="progressiveImage"
                        :placeholder-data="placeholderSlots[index]"
                        class="single-mini-hero-banner__item print-hide"
                        @placeholderError="incrementPlaceHolderErrorsCount"
                    />
                </slide>
            </template>
        </CustomCarousel>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CustomCarousel from '~/components/common/Carousel/CustomCarousel';
import DoubleClick from '~/components/common/DoubleClick';

export default {
    name: 'SingleMiniHeroBanner',
    components: {
        CustomCarousel,
        DoubleClick,
    },
    props: {
        doubleClickSlots: {
            type: Array,
            required: true,
        },
        placeholderSlots: {
            type: Array,
            default: () => [],
        },
        side: {
            type: String,
            required: true,
        },
        progressiveImage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            keysToBeNotDisplayed: [],
        };
    },
    computed: {
        ...mapState({
            adBlockDetected: state => state.adblock,
            gptLoaded: state => state.googleServices.GPT,
        }),
        maxOfSlots() {
            return Math.min(this.placeholderSlots.length, this.doubleClickSlots.length);
        },
        showPlaceHolders() {
            return this.placeholderSlots && (this.adBlockDetected || !this.gptLoaded);
        },
        slotsToDisplay() {
            if (this.showPlaceHolders) {
                return this.doubleClickSlots.slice(0, this.maxOfSlots);
            }
            return this.doubleClickSlots;
        },
        navigationEnabled() {
            return !!this.slotsToDisplay.length > 1;
        },
    },
    created() {
        if (this.showPlaceHolders && this.maxOfSlots <= 0) {
            this.$emit('empty', this.side);
        }
    },
    methods: {
        incrementPlaceHolderErrorsCount({ id }) {
            this.keysToBeNotDisplayed.push(id);
            if (this.keysToBeNotDisplayed.length >= this.slotsToDisplay.length) {
                this.$emit('empty', this.side);
            }
        },
    },
};
</script>

<style lang="scss">
    .single-mini-hero-banner {
        &__carousel {
            width: 100%;

            &--image {
                width: 100%;
                height: 235px;
            }
        }

        &__item {
            width: 100%;
        }
    }

    @media (min-width: $breakpoint-small-desktop) and (max-width: $breakpoint-big-desktop) {
        .single-mini-hero-banner__item {
            height: 186px;
        }
    }

</style>
